module.exports = __webpack_public_path__ + "img/huevos.b3e63ec2.svg";